import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0c22d60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-input" }
const _hoisted_2 = ["type", "name", "placeholder", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      type: _ctx.type,
      class: _normalizeClass(["a-input__body", [_ctx.errorInvalidClassName]]),
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      maxlength: _ctx.maxLength,
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blurUpdateValidateError && _ctx.blurUpdateValidateError(...args)))
    }, null, 42, _hoisted_2), [
      [_vModelDynamic, _ctx.inputValue]
    ]),
    (_ctx.visiblePassword)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "a-input__switch",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchVisiblePassword && _ctx.switchVisiblePassword(...args)))
        }, _toDisplayString(_ctx.passwordBody), 1))
      : _createCommentVNode("", true)
  ]))
}